<template>
  <div class="AppointmentInform">
    <div class="box" v-if="type == 'Apply'">
      <img class="submit-icon" src="../../../../static/images/phonePage/submit.svg" alt="预约信息提交成功">
      <p class="title">预约信息提交成功！</p>
      <p class="text">已向被访者发送信息，待被访者同意后将信息通知预约结果，预约成功后，请在门口门禁处刷身份证刷脸后进入</p>
    </div>
    <div class="box" v-else>
      <!-- <img class="submit-icon" src="../../../../static/images/icon/success.png" alt="提交成功"> -->
      <span class="success-icon el-icon-circle-check"></span>
      <p class="title">提交成功</p>
    </div>
  </div>
</template>

<script>
  import { RKEApi } from "../../../../static/js/phone/phoneApi.js"
  import { vconfirm, vshowSuccess, vNotify } from "../../../../static/js/phone/utility.js"
  let vm 

  export default {
    name:'RKEAppointmentInform',
    data(){
      return {
        type: ''
      }
    },
    components:{
    },
    created(){
      // console.log('tag', this.$route)
      vm = this
      vm.type = vm.$route.params.type
    },
    mounted(){
    },
    methods:{

    },
    watch:{
    }
  }
</script>

<style lang="scss">
  .van-notify {
    line-height: 0.56rem;
    padding: 0;
    font-size: 12px;
  }
  .AppointmentInform {
    height: 100vh;
    background-color: #F0F2F2;
    padding-top: 30%;
    .box {
      width: 4rem;
      margin: 0 auto;
      text-align: center;
    }
    .submit-icon {
      width: 1.28rem;
      height: 1.28rem;
    }
    .success-icon {
      font-size: 1.4rem;
      color: #2d83f4;
    }
    .title {
      font-size: 0.28rem;
      line-height: 0.34rem;
      margin: 0.2rem 0;
    }
    .text {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PhonePage/RKEAppointment/AppointmentInform.vue